import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import FormInput from '../input/FormInput';

function StringTransform({ name, reference, ...props }) {
    const {
        watch,
        setValue,
        clearErrors,
        trigger,
        getValues,
        // wrap
    } = useFormContext();

    useEffect(() => {
        const value = getValues(name);

        const result = value?.toString();

        // calling setValue does not call onChange
        // validation methods need to manually be called
        clearErrors([name]);
        setValue(name, result);
        trigger([name]);
    }, [watch(name)]);

    return <FormInput name={name} {...props} />;
}

export default StringTransform;
